import React from 'react';
import '../styles/ResumeDownload.css';

const ResumeDownload = () => {
  const downloadResume = () => {
    const link = document.createElement('a');
    link.href = '/CV_Ahmed Hossam Abdelrahman Awwad.pdf';
    link.download = 'CV_Ahmed_Hossam_Abdelrahman.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <section className="resume-download" id="resume">
      <div className="container">
        <h2>Resume</h2>
        <div className="resume-content">
          <p>
            Interested in my background in AI engineering? Download my complete resume to learn more
            about my experience in LLM systems, multi-agent architectures, computer vision, and
            production-ready AI applications.
          </p>
          <button className="download-btn" onClick={downloadResume}>
            <span className="download-icon">PDF</span>
            Download Resume (PDF)
          </button>
          <div className="resume-highlights">
            <div className="highlight-item">
              <h4>Education</h4>
              <p>B.Sc. Electronics & Communications Engineering, Helwan University</p>
            </div>
            <div className="highlight-item">
              <h4>Achievements</h4>
              <p>Favikon #2 AI Research Egypt, GDSC Founder</p>
            </div>
            <div className="highlight-item">
              <h4>Specialties</h4>
              <p>LLM Systems, Multi-Agent AI, Computer Vision</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ResumeDownload;
